import { render, staticRenderFns } from "./compatibility-checker.vue?vue&type=template&id=3f245ec0&"
import script from "./compatibility-checker.vue?vue&type=script&lang=ts&"
export * from "./compatibility-checker.vue?vue&type=script&lang=ts&"
import style0 from "./compatibility-checker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "compatibility-checker.vue"
export default component.exports